import { useEffect, useState } from "react";
import { CommonImages } from "../../../../reusableUI/images";
import { getContactNumber } from "../../../../Service/serviceVisits";
import { formatPhoneNumber } from "../../../../utils/Functions";
import { IoMdCall } from "react-icons/io";
import { capitalizeFirstLetter } from "../../../../utils/Functions";

const Callmodal = ({ isOpen, onClose, id, name, role }) => {
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (id) {
      getNumber();
      console.log(id);
    }
  }, [id]);

  const getNumber = async () => {
    try {
      const result = await getContactNumber(id);
      console.log(result);
      if (result.error === false) {
        console.log(result.data);
        setPhone(result.data);
      } else {
        console.log(result.error);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  if (!isOpen) return null;
  console.log(role);
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="flex flex-col items-center bg-white rounded-md shadow-lg w-96 border border-blue-400">
        <div className="flex flex-row justify-between w-full text-md font-semibold mb-6 p-2 pb-2 border-b-2">
          <div className="flex flex-row items-center gap-2">
            <p className="text-md text-[#4951EC]">
              Call {capitalizeFirstLetter(role)}
            </p>
          </div>

          <img
            src={CommonImages.close}
            onClick={onClose}
            className="h-6 w-6 cursor-pointer "
            alt="Close"
          />
        </div>

        <img
          src={CommonImages.CommonDp}
          className="h-20 w-20 rounded-full mb-4"
          alt="Profile"
        />
        <p className="text-sm text-[#4951EC] mb-2">
          {name} ({capitalizeFirstLetter(role)})
        </p>
        <p className="text-sm text-[#4951EC] mb-2"></p>
        <div className="flex flex-row items-center gap-2 pb-8">
          <IoMdCall color={"#4951EC"} size={18} />
          <p className="text-sm text-gray-600 font-medium">
            {formatPhoneNumber(phone)}
          </p>
        </div>
      </div>
    </div>
  );
};
export default Callmodal;
